const config = {
    basename: '',
    google_analytics: 'G-FPSQYJC6GP'
};

export default config;
